import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { FormattedDate } from 'react-intl';
import { flatProductList, NeuroMessage, useProducts, useDispatch, useUser, useAnswers, useGuideConfig, ContactFormModal, sendToLeadProcessor } from '@ignitesales/neuro-application';
import AnswersList from '../AnswersList.jsx';
import SocialActions from '../SocialActions.jsx';
import ProductList from '../ProductList.jsx';
import { analyticEvents, processEvent, processHmdAnswers, processHmdRecommend } from '../../utils/analytics';
import { installChat, uninstallChat } from '../../utils/installChat';
import PathOptionButtons from "../PathOptionButtons";
import FinancialHealthScore from "../FinancialHealthScore";
import cognitoConfig from '../../utils/cognitoConfig.js';
import saveKafkaStatus from '../../../../../../regionsBranchTheme/src/shared/js/utils/saveKafkaStatus.js';

function SummaryPage({ classname, detailsUrl }) {
  const dispatch = useDispatch();
  const { uuid } = useUser();
  const { answers } = useAnswers();
  const { products } = useProducts();
  const { isMockMode, runMode, guideId } = useGuideConfig();
  const productList = flatProductList(products);
  const [ showContactModal, setContactModalView ] = useState(false);
  const [ appointmentHasBeenScheduled, setAppointmentHasBeenScheduled ] = useState(answers?.appointmentId?.value.length > 0);

  const completedPathsAnswer = isMockMode ? ['bank', 'financialHealthScore'] : answers?.completedPaths?.value;
  const recommendationDate = <FormattedDate value={Date.now()} year="numeric" month="long" day="2-digit" />;
  const reasonForVisitAnswer = useState(answers?.reasonForVisit?.value);
  const bankingRelationshipAnswer = useState(answers?.bankingRelationship?.value);
  const leadProcessorCommand = { command: 'GenericRest', uuid, guideId };
  const pageCssBEM = 'summaryPage';
  const classes = classnames({
    [pageCssBEM]: true,
    [classname]: !!classname
  });
  const isConsumerOnline = guideId === 59;

  const sendLeadProcessor = async (action) => {
    //Could not call dispatch(func()) tested with Oliver and Ed and decided to go this route
    try {
      const response = await sendToLeadProcessor(cognitoConfig(), leadProcessorCommand);
      const data = await response(dispatch)
      const result = data?.isSuccess ? data.isSuccess : data;
      saveKafkaStatus('kafka_lead_success','SummaryPage',`sendLeadProcessor-${action}`, result);
    } catch (error) {
      saveKafkaStatus('kafka_lead_error','SummaryPage',`sendLeadProcessor-${action}`, error.message);
    }
  }

  useEffect(() => {
    installChat(runMode);
    return () => {
      uninstallChat();
    }
  }, []);

  useEffect(() => {
    saveKafkaStatus('kafka_lead_success', 'SummaryPage', 'use effect', 'Init summary page');

    const executeLeadProcessor = async () => {
      try {
        const response = await sendToLeadProcessor(cognitoConfig(), leadProcessorCommand);
        const data = await response(dispatch)
        const result = data?.isSuccess ? data.isSuccess : data;
        saveKafkaStatus('kafka_lead_success','SummaryPage','executeLeadProcessor', result);
      } catch (error) {
        saveKafkaStatus('kafka_lead_error','SummaryPage','executeLeadProcessor', error.message);
      }
    };

    executeLeadProcessor();

    let products = [];
    let productIds = '';
    if (productList.length) {
      products = productList.map((p) => (p.id));
      productIds = products.join(',');
    }
    !isConsumerOnline && processHmdAnswers(uuid, reasonForVisitAnswer, bankingRelationshipAnswer, productIds);
  }, []);

  const onCtaClick = async () => {
    processEvent({
      eventType: analyticEvents.click,
      description: 'Call To Action: Financial Health Score - appointment'
    });
    setContactModalView(true);
    if(guideId === 59) {
      await sendLeadProcessor('onCtaClick');
    }
  };

  return (
    <div className={ classes }>
      <div className={`${pageCssBEM}__image`}/>
      <div className={ `${ pageCssBEM }__content` }>
        <div className={ `${ pageCssBEM }__products` }>
          <h1 className={ `${ pageCssBEM }__header` }>
            <NeuroMessage id="summary.recommendationsOne"/>
            <br />
            <NeuroMessage id="summary.recommendationsTwo"/>
          </h1>
          { productList.length ? <ProductList products={ productList } onShowContactModal={() => setContactModalView(true)} appointmentScheduled={appointmentHasBeenScheduled} /> : null }
        </div>

        {/* <FinancialHealthScore isMockMode={isMockMode} onShowContactModal={onCtaClick} appointmentScheduled={appointmentHasBeenScheduled} /> */}

        <div className={ `${ pageCssBEM }__userActions` }>
          <NeuroMessage id="summary.recommendationId" values={{uuid: uuid, date: recommendationDate}} tagName="p" />
          <SocialActions leadProcessor={leadProcessorCommand} detailsUrl={ detailsUrl } />
        </div>

        <PathOptionButtons completedPaths={ completedPathsAnswer } uuid={uuid} />
        <AnswersList answers={ answers } />
      </div>

      <ContactFormModal
        className='contactMe'
        isOpen={ showContactModal }
        onClose={ () => setContactModalView(false) }
        useAppointmentFlow={true}
        onComplete={ () => setAppointmentHasBeenScheduled(true) }
        closeBtn={'x'}
        backButton={'Back'}
        cognitoConfig={ cognitoConfig() }
        leadProcessor={ leadProcessorCommand }
      />
    </div>
  );
}

export default SummaryPage;
